import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';
import { RouterModule } from '@angular/router';
import { GetPdfIdPipe } from "../../../../Services/pipes/get-pdf-id.pipe";
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-my-order',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, GetPdfIdPipe],
  templateUrl: './my-order.component.html',
  styleUrl: './my-order.component.css'
})
export class MyOrderComponent implements OnInit {
  PREP_UserInfo: any;
  payment_pending: any[] = [];
  payment_success: any[] = [];
  FYearList: string[] = [];
  selectedYear: string = "";
  selectedStatus: string = 'All';

  IsShowMessage: boolean = false;


  courierDetails: any = null;
  orderDetails: any;
  shippingAddress: any;
  trackingHistory: any;


  constructor(public _svc: SharedService) {
    this.FYearList = this._svc.FYearList();
    this.selectedYear = this._svc.FYear();

  }

  ngOnInit(): void {
    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe(x => {
        this.PREP_UserInfo = x;
        if (this.PREP_UserInfo != null) {
          this.MyOrders();

        }
      });
  }

  toUtc(dateStr: string) {
    return new Date(dateStr.replace(' ', 'T') + 'Z'); // "2025-08-29T08:22:50.900Z"
  }
  MyOrders(): void {
    this._svc.GET(API_End_Point.MyOrders(this.PREP_UserInfo.userId, this.selectedYear))
      .subscribe((res) => {
        if (res.result === 'success') {

          this.IsShowMessage = false;

          this.payment_success = res.payment_success || [];
          this.payment_pending = res.payment_pending || [];
          console.log(this.payment_success);
          console.log(this.payment_pending);
          this.filteredOrders();
        } else {
          this.payment_success = [];
          this.payment_pending = [];
          this._svc.Notification('error', res.message || 'Something went wrong while fetching your orders.');
          this.IsShowMessage = true;
        }
      });
  }

  filteredOrders() {
    if (this.selectedStatus === 'Success') {
      return this.payment_success;
    } else if (this.selectedStatus === 'Pending') {
      return this.payment_pending;
    }
    else if (this.selectedStatus === 'All') {
      return [...this.payment_success, ...this.payment_pending];
    }

    else {
      return [];
    }
  }

  trackOrder(orderID: number): void {
    this._svc.GET(API_End_Point.TrackOrder(orderID)).subscribe((res) => {
      if (res?.result === 'success') {
        this.orderDetails = res.orderDetails || [];
        this.shippingAddress = res.shippingAddress || null;
        this.trackingHistory = res.dataList || [];
        this.courierDetails = res.courierDetails || null;
        const modalElement = document.getElementById('orderModal');
        if (modalElement) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
        }
      } else {
        this._svc.Notification('error', res.message || 'No order details found for this order.');
      }
    });
  }

  payNow(order: any): void {
    const amountInPaise = Math.round(order.orderAmount * 100);
    const razorpayPayload = {
      amount: amountInPaise,
      currency: 'INR',
      payment_capture: true,
      key: environment.SZF_Key,
      secret: environment.SZF_Secret,
      orderNumber: order.orderNumber
    };

    this._svc.POST(razorpayPayload, API_End_Point.CreateOrder).subscribe({
      next: (res: any) => {
        if (res.result.toLowerCase() === 'success') {
          const options: any = {
            key: environment.SZF_Key,
            amount: amountInPaise,
            currency: 'INR',
            name: 'Silverzone Foundation',
            description: order.orderNumber,
            order_id: res.data.orderId,
            receipt: res.data.receipt,
            image: 'assets/Images/logotr.png',
            payment_capture: true,
            prefill: {
              name: this.PREP_UserInfo?.username || '',
              email: this.PREP_UserInfo?.email || '',
              contact: this.PREP_UserInfo?.mobile || ''
            },
            theme: { color: '#3399FF' },
            handler: (response: any) => {
              const verifyPayload = {

                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                razorpay_order_id: response.razorpay_order_id,
                orderNumber: order.orderNumber,
                refrenceType: 1,
                amount: order.orderAmount,
                shippingCharge: 0,
                amountPaise: amountInPaise,
                conversionRate: 0,
                key: environment.SZF_Key,
                secret: environment.SZF_Secret,
                couponId: 0,
                discountAmount: 0,
                couponCode: "",
                otp: '',
                mobile: this.PREP_UserInfo?.mobile || '',
                username: this.PREP_UserInfo?.userName || ''

              };

              this._svc.POST(verifyPayload, API_End_Point.VerifyPayment).subscribe({
                next: (verifyRes: any) => {
                  if (verifyRes.result === 'success') {
                    this._svc.Notification('success', `Payment successful for ₹${order.orderAmount}`);
                    this.MyOrders(); // refresh orders
                  }
                }
              });
            },
            modal: {
              ondismiss: () => {
                this._svc.Notification('info', 'Payment cancelled.');
              }
            }
          };

          const rzp = new this._svc.nativeWindow.Razorpay(options);

          rzp.on('payment.failed', (response: any) => {
            const failPayload = {
              orderNumber: order.orderNumber,
              RefrenceType: 1,
              Amount: order.orderAmount,
              RZ_Payment_id: response.error.metadata.payment_id,
              Payment_Status: response.error.description
            };
            this._svc.POST(failPayload, API_End_Point.UpdatePaymentFailed).subscribe();
            this._svc.Notification('error', 'Payment failed.');
          });

          rzp.open();
        } else {
          this._svc.Notification('error', res.message || 'Unable to initiate payment.');
        }
      },
      error: () => {
        this._svc.Notification('error', 'Something went wrong while creating Razorpay order.');
      }
    });
  }

}
